import React from "react"
import classnames from "classnames"

import "./styles.scss"

export default function InlineButtons(props) {
  const options = [...props.options].reverse()
  if (props.instruction) {
    options.unshift({ instruction: props.instruction })
  }
  return (
    <ul
      className={classnames("fontCaps inlineButtons", props.className)}
      style={props.style}
    >
      {options.map((option) => {
        if (option.instruction) {
          return (
            <li key="instruction" style={{ pointerEvents: "none" }}>
              {props.instruction}
            </li>
          )
        }
        const label = option.label || option
        const value = option.value || option
        const onClick = option.onClick || (() => props.setValue(value))
        return (
          <li
            onClick={onClick}
            className={classnames(option.className, {
              selected: value === props.value,
            })}
            key={label}
          >
            {label}
          </li>
        )
      })}
    </ul>
  )
}

InlineButtons.defaultProps = {
  className: null,
}
